import React from 'react';
import { Video, Clock, Users, Zap, Star } from 'lucide-react';

const LiveCoaching = () => {
  return (
    <div className="max-w-2xl mx-auto space-y-6 py-4" data-testid="live-coaching-coming-soon">
      {/* Hero Card */}
      <div className="relative overflow-hidden bg-gradient-to-br from-[#FF6600] to-[#FF8533] rounded-2xl p-8 text-white text-center">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-4 right-4 w-32 h-32 border-2 border-white rounded-full"></div>
          <div className="absolute bottom-4 left-4 w-20 h-20 border-2 border-white rounded-full"></div>
        </div>
        <div className="relative z-10">
          <div className="w-20 h-20 bg-white/20 backdrop-blur rounded-2xl flex items-center justify-center mx-auto mb-5">
            <Video size={36} className="text-white" />
          </div>
          <h2 className="text-2xl font-bold mb-2">Live Video Coaching</h2>
          <div className="inline-flex items-center gap-2 px-4 py-1.5 bg-white/20 backdrop-blur rounded-full text-sm font-semibold mb-4">
            <Clock size={14} />
            Coming Soon
          </div>
          <p className="text-white/90 text-sm leading-relaxed max-w-md mx-auto">
            Connect face-to-face with certified fitness and nutrition coaches 
            for personalized guidance, form checks, and live workout sessions.
          </p>
        </div>
      </div>

      {/* Features Preview */}
      <div className="bg-white dark:bg-gray-800 rounded-2xl p-6 shadow-sm">
        <h3 className="font-bold text-gray-900 dark:text-white mb-4 text-center">What to Expect</h3>
        <div className="grid grid-cols-2 gap-4">
          {[
            { icon: Users, title: '1-on-1 Sessions', desc: 'Personal training with certified coaches', color: 'bg-blue-100 text-blue-600' },
            { icon: Video, title: 'HD Video Calls', desc: 'Crystal clear live video sessions', color: 'bg-green-100 text-green-600' },
            { icon: Zap, title: 'Form Checks', desc: 'Real-time technique feedback', color: 'bg-purple-100 text-purple-600' },
            { icon: Star, title: 'Expert Guidance', desc: 'Certified nutrition & fitness pros', color: 'bg-orange-100 text-orange-600' },
          ].map((feature, i) => (
            <div key={i} className="p-4 rounded-xl border border-gray-100 dark:border-gray-700 text-center">
              <div className={`w-10 h-10 ${feature.color} rounded-full flex items-center justify-center mx-auto mb-2`}>
                <feature.icon size={18} />
              </div>
              <h4 className="font-semibold text-sm text-gray-900 dark:text-white mb-1">{feature.title}</h4>
              <p className="text-xs text-gray-500 dark:text-gray-400">{feature.desc}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Notify Card */}
      <div className="bg-orange-50 dark:bg-orange-900/20 border border-orange-200 dark:border-orange-800 rounded-2xl p-5 text-center">
        <p className="text-sm text-orange-800 dark:text-orange-300 font-medium">
          We're working hard to bring you live coaching. Stay tuned for updates!
        </p>
      </div>
    </div>
  );
};

export default LiveCoaching;
